export const connectionInfo = () => {
    if (!navigator.connection) {
        return null;
    }

    return [
        'downlink',
        'downlinkMax',
        'effectiveType',
        'rtt',
        'type',
        'saveData'
    ].reduce((acc, prop) => {
        if (navigator.connection[prop]) {
            return Object.assign(acc, {
                [prop]: navigator.connection[prop]
            });
        }

        return acc;
    }, {});
};

export const batteryInfo = async () => {
    if (!navigator.getBattery) {
        return null;
    }

    try {
        const details = await navigator.getBattery();
        return {
            ...('charging' in details && { charging: details.charging }),
            level: details.level || 'unknown'
        };
    } catch (error) {
        return 'unknown';
    }
};
